<template>

  <div class="user-section-heading">My Offers</div>

  <v-divider class="my-7" />

  <StatusButtons>
    <template #[OfferStatus.Started]>
      <InProgressOffer></InProgressOffer>
    </template>
    
    <template #[OfferStatus.Completed]>
      <CompletedOffer></CompletedOffer>
    </template>
    
    <template #[OfferStatus.Expired]>
      <ExpiredOffer></ExpiredOffer>
    </template>
  </StatusButtons>

</template>



<script lang="ts" setup>
import { onMounted } from "vue";
import { OfferStatus } from "@/interfaces/Offers/OfferStatus";
import { OfferStatusStore } from "@/store/OfferStatusStore";

import ExpiredOffer from "@/components/Offer/Status/ExpiredOffer.vue";
import StatusButtons from "@/components/Offer/Status/Status-Buttons.vue"
import CompletedOffer from "@/components/Offer/Status/CompletedOffer.vue";
import InProgressOffer from "@/components/Offer/Status/InProgressOffer.vue";

// Initialize the offer status store
const offerStatusStore = OfferStatusStore();

onMounted(() => {
  // Load all offers data on mount
  offerStatusStore.getAllMyOffers();
});
</script>



<style scoped lang="scss">
.container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 15px;
}
</style>
